import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputCombo from "../../helpers/InputCombo";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import InputDecimal from "../../helpers/InputDecimal";
import InputDate from "../../helpers/InputDate";
import SortBy from "../../helpers/SortBy";

import search from "../../search.png";
import AppContext from "../../AppContext";
import InputText from "../../helpers/InputText";
import Xlsx from "../../exporter/Xlsx";


function Saldo(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filterParam, setFilterParam] = useState({
 
        
        p_subkonta_id: props.mainView.readFilter('p_subkonta_id','_x_'),  

        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''), 
        r_imie_nazwisko: props.mainView.readFilter('r_imie_nazwisko',''), 
 

        kwota_od: '',
        kwota_do: '',

        strona: '_x_',

        fraza: '',


        data_od: props.mainView.readFilter('data_od',''), 
        data_do: props.mainView.readFilter('data_do',''), 


        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },
    
     
        limit: 50,
        page: 1,
        pages: 1,
        show: true,

    });

    const [tab, setTab] = useState(null);
 

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0); //do druku

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );




    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = (e) => {

        setView({...view, ["v"]:"list", ["id"]:"-1" }); 
        getTab();
        
    }



   
    const getTab = () => {
            
        
        props.mainView.setProgress(-2);
    

        fetch( Config.url + '/rest_v1_calc,calc_history', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);  

                       

                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }



    
    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {
 
        props.mainView.writeFilter('p_subkonta_id', '_x_'); 
        props.mainView.writeFilter('r_imie_nazwisko', ''); 
        props.mainView.writeFilter('d_imie_nazwisko', ''); 
 

        props.mainView.writeFilter('data_od', ''); 
        props.mainView.writeFilter('data_do', ''); 
   

        setFilterParam({
     
            
            r_imie_nazwisko: '', 
            d_imie_nazwisko: '', 
        

            p_subkonta_id: '_x_',    

            strona: '_x_',
            fraza: '',

            kwota_od: '',
            kwota_do: '',

            data_od: '',
            data_do: '',

            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
                                       
            limit: 50,
            page: 1,
            show: true
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }



    const searchParent = (e) => {

        var search = e.target.getAttribute("search");
        //alert(search);

        setFilterParam( {...filterParam, ["r_imie_nazwisko"]:search,  ["r_imie_nazwisko_valid"]:true } );
        setTab(null);
    }    


    
    if(tab == null)
        {
            setTab([]);
            getTab();
        
    
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }



    var sumKwota = 0;
    var sumKwota2 = 0;



    var sortList = [                
        {column: "kwota", name: "Kwota"  }, 
        {column: "data", name: "Data"  },        
        {column: "rodzic_nazwisko", name: "Rodzic"  },
        {column: "dziecko_nazwisko", name: "Dziecko"  },
]

    var itemsStrona = [
        {v: '_x_', title: '- - - '},
        {v: 'ma', title: 'Uznania (MA)'},
        {v: 'wn', title: 'Obciążenia (WN)'},
    ];


    return <div className="view_content">
 

                
                <div className="bg_center">



                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                    <div className="table_filter">

                    <div className="filter_controll">   
                            <label>Strona: </label>                             
                            <InputCombo items={itemsStrona} userData={props.userData}  mainView={props.mainView}  value={filterParam.strona}   valChange={valChangeListener} goNext={goNextNew} name="strona" placeholder={" "}   />
                        </div> 

                          <div className="filter_controll">   
                            <label>Subkonto: </label>                             
                            <InputComboSubkonto userData={props.userData}  mainView={props.mainView}  value={filterParam.p_subkonta_id}   valChange={valChangeListener} goNext={goNextNew} name="p_subkonta_id" placeholder={" "}   />
                        </div> 

                                       
                        <div className="filter_controll">   
                            <label>Rodzic: </label>                             
                            <InputTextAlpha   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="r_imie_nazwisko" placeholder={"Rodzic: "}   />
                       </div> 

                       <div className="filter_controll">   
                            <label>Dziecko: </label>                             
                            <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                       </div> 

                       <div className="filter_controll">   
                            <label>Fraza / opis: </label>                             
                            <InputText  userData={props.userData} value={filterParam.fraza}   valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Fraza: "}   />
                       </div> 



                        <div className="filter_controll filter_merge">   
                              <label>Kwota (od / do): </label>        
                              <br/>                     
                              <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_od" placeholder={" "}   />
                             <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_do" placeholder={" "}   />
                         </div> 


                         
                    <div className="filter_controll filter_merge">   
                                <label>Data (od dnia / do dnia): </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}   />
                    </div> 


                         <div className="filter_btn">
                            <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                            <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>

                  </div>
                } 
                           


                            <div className="table_widget">
                                            <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                            
                                          
                                            &nbsp; &nbsp;
                                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Rozliczenia" />   
                                            <Csv tabRef={tab2Ref}  title="Historia salda.csv" />                  
                                            <Xlsx tabRef={tab2Ref} title="Historia salda.xlsx" />                  
                                            <Print tabRef={tab2Ref} />

                                            <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                                </div>


                                <div ref={tabRef} className="gohide">
                                    <table className="table" ref={tab2Ref} >
                                                        <thead>
                                                            <tr className="header">                                                                                                       
                                                                <td>LP</td>  
                                                                <td>Data</td>                                                                                                                           
                                                                <td>Rodzic</td>                                                                                                                           
                                                                <td>Subkonto</td>                                                                                                                           
                                                                <td>Opis</td>
                                                                <td>Strona</td>                                                                                                                             
                                                                <td>Kwota</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {
                                                                tab.map( (row,ix) => {

                                                                    var st = "Uznanie";
                                                                    var cssNum = "amount_plus";


                                                                    if(row.strona == 'wn') 
                                                                    {
                                                                        st = "Obciążenie";
                                                                        cssNum = "amount_minus";
                                                                    }

                                                                    sumKwota2 = parseFloat(sumKwota2) + parseFloat(row.kwota);


                                                                    var rowStyle = " row ";
                                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                                    return <tr className={rowStyle}>                                                                                                       
                                                                        <td>{ix+1}</td>  
                                                                        <td className="gocenter">{row.data}</td>                                                                                                                           
                                                                        <td>{row.rodzic.nazwisko +" " + row.rodzic.imie}</td>
                                                                        <td>{row.subkonto.nazwa}</td>
                                                                        <td>{row.opis}</td>
                                                                        <td className="gocenter">{st}</td>                                                                                                                             
                                                                        <td className={"goright gobold " + cssNum}><FormatDecimal value={row.kwota} /></td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                    </tr>    

                                                                } )
                                                            }

                                                        <tr className="row">                                                                                                       
                                                                        <td> </td>  
                                                                        <td className="gocenter"> -- </td>                                                                                                                           
                                                                        <td>--</td>
                                                                        <td>--</td>
                                                                        <td>--</td>  
                                                                        <td className="gocenter gobold">Razem z widocznych</td>                                                                                                                             
                                                                        <td className={"goright gobold " }><FormatDecimal value={sumKwota2} /></td> 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                                    </tr> 
                                                        </tbody>
                                    </table>
                                </div>

                            <div className="scorll_x">
                                <table className="table" >
                                                    <thead>
                                                        <tr className="header">                                                                                                       
                                                            <td className="td_left">LP</td>  
                                                            <td>Data</td>                                                                                                                           
                                                            <td>Rodzic</td>                                                                                                                           
                                                            <td>Konto</td>                                                                                                                           
                                                            <td>Opis</td>
                                                            <td>Strona</td>                                                                                                                             
                                                            <td className="td_right">Kwota</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            tab.map( (row,ix) => {

                                                                var st = "Uznanie";
                                                                var cssNum = "amount_plus";


                                                                if(row.strona == 'wn') 
                                                                {
                                                                    st = "Obciążenie";
                                                                    cssNum = "amount_minus";
                                                                }

                                                                sumKwota = parseFloat(sumKwota) + parseFloat(row.kwota);

                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";


                                                                return <tr className={rowStyle}>                                                                                                       
                                                                    <td>{ix+1}</td>  
                                                                    <td className="gocenter">{row.data}</td>                                                                                                                           
                                                                    <td>
                                                                        {row.rodzic.nazwisko +" " + row.rodzic.imie} 
                                                                        <img src={search} className="small_tip_img" title="Pokaż tylko tego rodzica"  search={row.rodzic.nazwisko + " " + row.rodzic.imie} onClick={searchParent} />
                                                                    </td>
                                                                    <td className="gocenter">{row.subkonto.nazwa}</td>
                                                                    <td>{row.opis}</td>
                                                                    <td className="gocenter">{st}</td>                                                                                                                             
                                                                    <td className={"goright gobold " + cssNum}><FormatDecimal value={row.kwota} /></td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                </tr>    

                                                            } )
                                                        }

                                                    <tr className="row">                                                                                                       
                                                                    <td> </td>  
                                                                    <td className="gocenter"> -- </td>                                                                                                                           
                                                                    <td>--</td>
                                                                    <td>--</td>
                                                                    <td>--</td>
                                                                    <td className="gocenter gobold">Razem z widocznych</td>                                                                                                                             
                                                                    <td className={"goright gobold " }><FormatDecimal value={sumKwota} /></td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                                </tr> 
                                                    </tbody>
                                </table>
                            </div>


                </div>


           </div>
}




export default Saldo;